//dependencias
import React, { Component } from 'react';

//componentes
import AsociarEva from './asociarEva'

class Index extends Component {

    render(){
        return(
            <div>
                <AsociarEva />
            </div>
        );
    }

}
export default Index;